/* import __COLOCATED_TEMPLATE__ from './permitted-locale-component.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { equalToProperty } from '@intercom/pulse/lib/computed-properties';

export default Component.extend({
  appService: service(),
  app: readOnly('appService.app'),
  attributeBindings: ['data-test-permitted-locale'],
  'data-test-permitted-locale': true,
  classNames: ['flex', 'items-start'],
  isDefaultLocale: equalToProperty('locale.localeId', 'defaultLocale.localeId'),
});
